export default __webpack_public_path__ + "static/media/marker-icon.1d2d333c.svg";